/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const imageHistoryDataCategorySchema = z.enum(['image', 'file'])

export type ImageHistoryDataCategorySchema = z.infer<typeof imageHistoryDataCategorySchema>
